import React from 'react';
import { FormattedMessage } from 'react-intl';

export enum UserActionName {
    USER_CHANGE_STATE = 'user_change_state',
    USER_INFORM_IOT_IDENTIFIED = 'user_inform_iot_identified'
}

export class UserAction {
    static readonly USER_CHANGE_STATE = new UserAction(
        UserActionName.USER_CHANGE_STATE,
        (
            <FormattedMessage
                id='UserAction.user_change_state'
                description='The displayed value for the UserAction user_change_state'
                defaultMessage='Change state'
            />
        )
    );

    static readonly USER_INFORM_IOT_IDENTIFIED = new UserAction(
        UserActionName.USER_INFORM_IOT_IDENTIFIED,
        (
            <FormattedMessage
                id='UserAction.user_inform_iot_identified'
                description='The displayed value for the UserAction user_inform_iot_identified'
                defaultMessage='Inform IoT identified'
            />
        )
    );

    static readonly ALL = [UserAction.USER_CHANGE_STATE, UserAction.USER_INFORM_IOT_IDENTIFIED];

    constructor(
        public readonly value: UserActionName | string,
        public readonly displayName: React.ReactNode
    ) {}

    static getByValue(action: string): UserAction | undefined {
        return this.ALL.find((a) => a.value === action);
    }
}
